import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { defaultManagerCodes, type ManagerCode } from '../utils/constants';
import { fallFoliageDefaultWeek, type FallFoliageWeek } from '../utils/fallFoliageLayers';

export type AdvancedMapLayersState = {
  isFallFoliagePlaying: boolean;
  selectedFallFoliageWeek: FallFoliageWeek;
  visibleManagers: ManagerCode[];
};

export const initialState: AdvancedMapLayersState = {
  isFallFoliagePlaying: false,
  selectedFallFoliageWeek: fallFoliageDefaultWeek,
  visibleManagers: [...defaultManagerCodes]
};

export const advancedMapLayersSlice = createSlice({
  name: 'advancedMapLayers',
  initialState,
  reducers: {
    updateIsFallFoliagePlaying: (state, action: PayloadAction<boolean>) => {
      state.isFallFoliagePlaying = action.payload;
    },
    updateSelectedFallFoliageWeek: (state, action: PayloadAction<FallFoliageWeek>) => {
      state.selectedFallFoliageWeek = action.payload;
    },
    updateVisibleManagers: (state, action: PayloadAction<ManagerCode[]>) => {
      state.visibleManagers = action.payload;
    }
  }
});

export const { updateIsFallFoliagePlaying, updateSelectedFallFoliageWeek, updateVisibleManagers } = advancedMapLayersSlice.actions;
export const advancedMapLayersReducer = advancedMapLayersSlice.reducer;
